import { getIdFromSlug } from 'utils/misc';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import ApiService from 'services';
import { Col, Row, Table, Image } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { slugify } from 'utils/misc';
import { GET_AWARD_ABBR } from 'constants/index';
import { getBowlingAvg, getBattingAvg, getBattingSR, getBowlingEconomy } from 'utils/misc';
import LoadingBar from 'components/LoadingBar';
import TCABreadCrumb from 'components/breadcrumb';
import { getTeamLink, getPlayerImage} from 'utils/links';

/**
 * 
 * https://tennisballcricket.com/chartsapi/batting/6452
 * https://tennisballcricket.com/chartsapi/bowling/6452
 * 
 * to get detailed stats in a tournament
 * https://tennisballcricket.com/teamplayerscore/player/6452/77
 */


const playerMenuOptions = [
    {
        "title": "Summary",
        "link": "summary"
    },
    {
        "title": "Tournament Stats",
        "link": "tournament"
    }
];
export default function PlayerDetails(props) {
    const { playerSlug } = useParams();
    const [playerId, setPlayerId] = useState("");
    const [data, setData] = useState(null);
    const [playerData, setPlayerData] = useState(null);
    const [awardData, setAwardData] = useState([]);
    const [activeTab, setActiveTab] = useState('summary');
    const [tournamentPerformance, setTournamentPerformance] = useState([]);
    const [tournaments, setTournaments] = useState([]);
    const [tournamentId, setTournamentId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [tLoading, setTLoading] = useState(true);


    useEffect(() => {
        setPlayerId(getIdFromSlug(playerSlug));
    }, [playerSlug]);
    useEffect(() => {
        if (playerId && playerId.length > 0) {
            setLoading(true);
            Promise.all([
                ApiService.getPlayerDetails(playerId),
                ApiService.getPlayerAwards(playerId),
                ApiService.getPlayerPerformanceInCurrentTournament(playerId),
            ])
                .then(([dataPlayer, dataAwards, playerPerformanceInTournament]) => {
                    setData(dataPlayer);
                    setPlayerData(dataPlayer?.player[0]);
                    setAwardData(dataAwards?.awards);
                    setTournaments(playerPerformanceInTournament?.Tour);
                    setTournamentPerformance(playerPerformanceInTournament?.Match[0])
                    setTournamentId(playerPerformanceInTournament?.LatestTour);
                    setLoading(false);
                });
        }
    }, [playerId]);
    useEffect(() => {
        // Effect logic to run when activeTab changes
        console.log('Active Tab Changed:', activeTab);
        // Cleanup function (if needed)
        return () => {
            // Cleanup logic here (if needed)
        };
    }, [activeTab]);
    useEffect(() => {
        if (playerId && tournamentId) {
            setTLoading(true);
            Promise.all([
                ApiService.getPlayerPerformanceInTournament(playerId, tournamentId),
            ])
                .then(([playerPerformanceInTournament]) => {
                    setTournamentPerformance(playerPerformanceInTournament?.Match[0]);
                    setTLoading(false);
                });
        }
    }, [playerId, tournamentId]);
    const handleTabSelect = (selectedTab) => {
        setActiveTab(selectedTab);
        // Do something with the selected tab
        console.log('Selected Tab:', selectedTab);
    };
    const getPlayerMenu = () => {
        if (loading) {
            return <LoadingBar show={loading} />
        }
        return <Tabs
            defaultActiveKey="summary"
            id="uncontrolled-tab-example"
            className="mt-3"
            fill
            onSelect={handleTabSelect}
        >
            {playerMenuOptions.map((oneOption, index) => {
                return <Tab eventKey={oneOption.link} key={index} title={oneOption.title}>
                    <div style={{ minHeight: "100vh" }}>
                        {getContentForTab(activeTab)}
                    </div>
                </Tab>
            })}

        </Tabs>
    }
    const renderPlayerAwards = () => {

        if (awardData && awardData.length > 0) {

            return awardData.map((oneAward, index) => (
                <tr>
                    <td> {GET_AWARD_ABBR(oneAward.AwardType)}</td>
                    <td>{oneAward.Year + " " + oneAward.Tournament}</td>
                </tr>
            ))
        }
        return <></>
    }
    const renderBattingStats = () => {
        if (data && data.Batting[0]) {
            return (
                <tr>
                    <td>{data.Batting[0]["P"]}</td>
                    <td>{data.Batting[0]["NO"]}</td>
                    <td>{data.Batting[0]["R"]}</td>
                    <td>{data.Batting[0]["B"]}</td>
                    <td>{getBattingAvg(data?.Batting[0], playerData)}</td>
                    <td>{getBattingSR(data?.Batting[0])}</td>
                    <td>{data.Batting[0]["Thirty"]}</td>
                    <td>{data.Batting[0]["Fourty"]}</td>
                    <td>{data.Batting[0]["Fifty"]}</td>
                    <td>{data.Batting[0]["Hundred"]}</td>
                    <td>{data.Batting[0]["Ducks"]}</td>
                    <td>{data.Batting[0]["Four"]}</td>
                    <td>{data.Batting[0]["Six"]}</td>
                    <td>{data.Batting[0]["DNB"]}</td>
                </tr>
            )

        }
        return <></>
    }
    const renderBowlingStats = () => {
        if (data && data.Bowling[0]) {
            return (
                <tr>
                    <td>{data.Bowling[0]["Overs"]}</td>
                    <td>{data.Bowling[0]["Maidens"]}</td>
                    <td>{data.Bowling[0]["Runs"]}</td>
                    <td>{data.Bowling[0]["Wickets"]}</td>
                    <td>{getBowlingAvg(data?.Bowling[0])}</td>
                    <td>{getBowlingEconomy(data?.Bowling[0])}</td>
                    <td>{data.Bowling[0]["Third"]}</td>
                    <td>{data.Bowling[0]["Fourth"]}</td>
                    <td>{data.Bowling[0]["Fifth"]}</td>
                    <td>{data.Bowling[0]["Wide"]}</td>
                    <td>{data.Bowling[0]["Noballs"]}</td>

                </tr>
            )

        }
        return <></>
    }
    const renderTournamentDropDown = () => {
        return <Form.Select onChange={(e) => setTournamentId(e.currentTarget.value)}>
            {tournaments && tournaments.length > 0 && tournaments.map((tournament, index) => (
                <option key={index} value={tournament.TourId}>{tournament.TourName}</option>
            ))}
        </Form.Select>
    }
    const renderTournamentPerformance = () => {
        if (tLoading) {
            return <LoadingBar show={tLoading} />
        }
        return <Table responsive bordered>
            <thead>
                <tr>

                    <th rowspan="2">Match</th>
                    <th colSpan="4">Batting</th>
                    <th colSpan="4">Bowling</th>
                    <th colSpan="3">Fielding</th>
                </tr>
                <tr >
                    <th>Runs</th>
                    <th>BF</th>
                    <th>4's</th>
                    <th>6's</th>
                    <th>O</th>
                    <th>M</th>
                    <th>R</th>
                    <th>W</th>
                    <th>C</th>
                    <th>St</th>
                    <th>RO</th>
                </tr>
            </thead>
            <tbody>

                {tournamentPerformance && tournamentPerformance.length > 0 && tournamentPerformance.map((oneMatch, index) => (
                    <tr>

                        <td><a href={"/match/" + slugify("TEST") + "-" + oneMatch.MatchDetails.MatchId}>{oneMatch.MatchDetails.Teams}</a></td>
                        <td>{oneMatch.Batting?.R}</td>
                        <td>{oneMatch.Batting?.B}</td>
                        <td>{oneMatch.Batting?.Four}</td>
                        <td>{oneMatch.Batting?.Six}</td>
                        <td>{oneMatch.Bowling?.Overs}</td>
                        <td>{oneMatch.Bowling?.Maidens}</td>
                        <td>{oneMatch.Bowling?.Runs}</td>
                        <td>{oneMatch.Bowling?.Wickets}</td>
                        <td>{oneMatch.Fileding?.C}</td>
                        <td>{oneMatch.Fileding?.St}</td>
                        <td>{oneMatch.Fileding?.RO}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    }
    const getContentForTab = () => {
        switch (activeTab) {
            case "summary":

                return <>

                    <Row>
                        <Col xs={12} md={10}>
                            {/** Summary */}
                            <h2>Career Summary</h2>
                            {playerData && <Table responsive bordered hover>
                                <thead>
                                    <tr>
                                        <th>Played</th>
                                        <th>Runs</th>
                                        <th>Wickets</th>
                                        <th>MoM</th>
                                        <th>Umpiring</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{playerData?.P}</td>
                                        <td>{playerData?.R}</td>
                                        <td>{playerData?.W}</td>
                                        <td>{playerData?.MOM}</td>
                                        <td>{playerData?.Umpiring}</td>
                                    </tr>
                                </tbody>
                            </Table>}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {awardData && awardData.length > 0 && <>
                                <h2>Awards</h2>
                                <Table responsive bordered>
                                    <tbody>
                                        {renderPlayerAwards()}
                                    </tbody>
                                </Table>
                            </>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h2>Career Stats</h2>
                            {/** Batting Statistics */}
                            {data && data.Batting && data.Batting[0] &&
                                <Table responsive bordered hover>
                                    <thead>
                                        <tr>
                                            <th colSpan="14"><Image src="/cricket-bat.svg" height={30} />Batting Stats</th>
                                        </tr>
                                    </thead>
                                    <thead>
                                        <tr>
                                            <th>Innings</th>
                                            <th>N.O.</th>
                                            <th>Runs</th>
                                            <th>Balls Faced</th>
                                            <th>Avg.</th>
                                            <th>SR</th>
                                            <th>30's</th>
                                            <th>40's</th>
                                            <th>50's</th>
                                            <th>100's</th>
                                            <th>Ducks</th>
                                            <th>4s</th>
                                            <th>6s</th>
                                            <th>DNB</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {renderBattingStats()}

                                    </tbody>
                                </Table>}
                            {/** Bowling Statistics */}
                            {data && data.Bowling && data.Bowling[0] &&
                                <Table responsive bordered hover>
                                    <thead>
                                        <tr>
                                            <th colSpan="11"><Image src="/cricket-ball.svg" height={30} />Bowling Stats</th>
                                        </tr>
                                    </thead>
                                    <thead>
                                        <tr>
                                            <th>Overs</th>
                                            <th>Maidens</th>
                                            <th>Runs</th>
                                            <th>Wickets</th>
                                            <th>Avg.</th>
                                            <th>Econ.</th>
                                            <th>3W/I</th>
                                            <th>4W/I</th>
                                            <th>5W/I</th>
                                            <th>Wides</th>
                                            <th>No Balls</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {renderBowlingStats()}

                                    </tbody>
                                </Table>}
                            {/** Fielding Statistics */}
                            {data && data.Fielding && data.Fielding[0] &&


                                <Table responsive bordered hover>
                                    <thead>
                                        <tr>
                                            <th colSpan="3">Fielding Stats</th>
                                        </tr>
                                    </thead>
                                    <thead>
                                        <tr>
                                            <th>Catches</th>
                                            <th>Stumpings</th>
                                            <th>Run Outs</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr>
                                            <td>{data?.Fielding[0]['C']}</td>
                                            <td>{data?.Fielding[0]['S']}</td>
                                            <td>{data?.Fielding[0]['R']}</td>
                                        </tr>

                                    </tbody>
                                </Table>}
                        </Col>
                    </Row>
                </>
                break;
            case "tournament":
                return <>
                    <Row className='justify-content-center'>
                        <Col xs={12} md={6}>
                            <h2>Performance In Tournaments</h2>
                            {renderTournamentDropDown()}
                            <br />
                        </Col>

                    </Row>
                    <Row>
                        <Col>
                            {renderTournamentPerformance()}
                        </Col>
                    </Row>
                </>
                break;
        }

    }
    const breadCrumbData = [
        {
            title: "All Players",
            link: "/players"
        },
        {
            title: playerData?.Name
        }
    ];
    return (
        <>
            <Row>
                <Col>
                    <TCABreadCrumb breadCrumbData={breadCrumbData} />
                    <h1 className='text-center'>{playerData?.Name}</h1>
                </Col>
            </Row>
            <Row className='justify-content-center'>
                <Col xs={12} md={10}>
                    {data && data.Batting && data.Batting[0] &&
                        <div className='border shadow-sm p-3 mb-5 bg-white rounded'>
                            <Row className='p-2'>
                                <Col xs={6} md={2} className='justify-content-center'>
                                    {getPlayerImage(playerData?.Photo)}
                                   
                                </Col>
                                <Col xs={6} md={2}>
                                    <p className='text-uppercase pt-3 m-0'>Full Name</p>
                                    <span className='fw-bold'>{playerData?.Name}</span>
                                </Col>
                                <Col xs={6} md={2}>
                                    <p className='text-uppercase pt-3 m-0'>Batting Style</p>
                                    <span className='fw-bold'>{playerData?.BattingStyle}</span>
                                </Col>
                                <Col xs={6} md={2}>
                                    <p className='text-uppercase pt-3 m-0'>Bowling Style</p>
                                    <span className='fw-bold'>{playerData?.BowlingStyle} Arm {playerData?.BowlStyle}</span>
                                </Col>
                                <Col xs={6} md={2}>
                                    <p className='text-uppercase pt-3 m-0'>Team</p>
                                    <span className='fw-bold'>
                                        {getTeamLink(playerData?.Club, playerData?.TeamId)}
                                    </span>
                                </Col>
                            </Row>
                        </div>
                    }
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className='d-block'>
                        {getPlayerMenu()}
                    </div>

                </Col>
            </Row>




        </>
    )
}